/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import React from 'react';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { FormHelperText } from '@mui/material';

import { useErrorMessageWithIconStyles } from './ErrorMessageWithIcon.styles';

type ErrorMessageWithIconProps = {
  message: string;
  className?: string;
};

export function ErrorMessageWithIcon(props: ErrorMessageWithIconProps) {
  const classes = useErrorMessageWithIconStyles();
  const { message, className } = props;

  return (
    <FormHelperText>
      <span className={cx(classes.errorWrap, className)}>
        <ErrorOutlineIcon className={classes.errorIcon} />
        <span className={classes.error}>{message}</span>
      </span>
    </FormHelperText>
  );
}
